import { Button, ButtonProps } from '@mui/material'
import React from 'react'

interface Props {
    children: ButtonProps['children']
    onClick: ButtonProps['onClick']
    disabled: ButtonProps['disabled']
    startIcon: ButtonProps['startIcon']
    type?: ButtonProps['type']
    color?: ButtonProps['color']
}

export const ShareModalButton: React.VFC<Props> = ({ onClick, disabled, startIcon, color, type, children }: Props) => {
    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            startIcon={startIcon}
            variant="contained"
            color={color}
            type={type}
            sx={{
                '& .MuiButton-startIcon': {
                    display: { xs: 'none', sm: 'inherit' },
                },
            }}
        >
            {children}
        </Button>
    )
}
